import { useLocale } from "next-intl";
import { useQuery } from "@tanstack/react-query";

import { getFavoriteSports } from "@/api/sportsNew";

export enum FavoriteSportsQueryKeys {
  All = "favoriteSports.all",
}

interface GetSportsOptions {
  name?: string;
  popular?: boolean;
}

export const useFavoriteSports = (options: GetSportsOptions = {}) => {
  const locale = useLocale();

  return useQuery({
    queryKey: [FavoriteSportsQueryKeys.All, locale],
    queryFn: ({ signal }) => {
      const params = { lang: locale, ...options };
      return getFavoriteSports({ params, signal });
    },
  });
};
